import { useState } from "react";
import { binaryToUint8Array, pickFileName } from "../utilities/tachographFiles";
import { useGeotabClient } from "@/components/GeotabClientContext";
import { safeFilename } from "@/utilities/mediaSafety";
import { downloadBlob } from "@/utilities/xlsx";

/** The file content is only fetched for the files a user really wants. */
export function useTachographFileDownload() {
  const { geotabClient } = useGeotabClient();
  const [isDownloading, setIsDownloading] = useState(false);

  const downloadFiles = async (fileIds: string[]) => {
    if (fileIds.length === 0 || isDownloading) return;

    setIsDownloading(true);
    try {
      for (const fileId of fileIds) {
        const [file] = await geotabClient.get(
          "TachographDataFile",
          { id: fileId, includeBinaryData: true },
          1,
        );

        const content = binaryToUint8Array(file?.binaryData);
        if (!content) continue;

        const fallbackName = `${fileId}.ddd`;
        downloadBlob(
          new Blob([content], { type: "application/octet-stream" }),
          safeFilename(pickFileName(file) || fallbackName, fallbackName),
        );
      }
    } finally {
      setIsDownloading(false);
    }
  };

  return { downloadFiles, isDownloading };
}
